import { NgIf, NgFor } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, Component, TemplateRef, ViewChild } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { CartLine, SiloDistributionRequirements } from '@next/core-lib/cart';
import { AgrI18nSharedModule } from '@next/core-lib/i18n';
import { Store } from '@ngrx/store';

import { openSiloDialog } from 'src/app/cart/store/actions';
import { AppState } from 'src/app/models/app.models';

@Component({
  templateUrl: './column-silo-distribution.component.html',
  styleUrls: ['./column-silo-distribution.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf, MatButton, MatIcon, NgFor, AgrI18nSharedModule],
})
export class ColumnSiloDistributionComponent implements AfterViewInit {
  @ViewChild('template') template: TemplateRef<unknown>;

  public noSilosNeeded = SiloDistributionRequirements.notRelevant;
  public cartId: number;
  public editable: boolean;
  public initCallback: () => void;

  constructor(private readonly store: Store<AppState>) {}

  ngAfterViewInit(): void {
    this.initCallback();
  }

  public openSiloDistribution(cartLine: CartLine): void {
    this.store.dispatch(openSiloDialog({ cartIdentifier: this.cartId, cartLine }));
  }
}
